import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StockyEntryService } from '@app/tvf/stock-entry/services/stocky-entry.service';
import { ToastrService } from 'ngx-toastr';

interface LotItem {
  id: string;
  lote: string;
  quantidade: number;
  dataFechamento: string;
  dataEntrega: string;
  motivo?: string;
}

@Component({
  selector: 'app-modal-devolution-reasons',
  templateUrl: './modal-devolution-reasons.component.html',
  styleUrls: ['./modal-devolution-reasons.component.sass'],
})
export class ModalDevolutionReasonsComponent implements OnInit {
  displayedColumns: string[] = ['lote', 'quantidade', 'dataFechamento', 'dataEntrega', 'motivo'];

  reasons = ['Quantidade divergente'];

  lots: LotItem[] = [
    {
      id: '',
      lote: 'RB_0012',
      quantidade: 15,
      dataFechamento: '13/05/2026 às 13:30:25',
      dataEntrega: '13/05/2026 às 13:30:25',
    },
  ];

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private stockyService: StockyEntryService,
    private toastr: ToastrService,
    private dialogRef: MatDialogRef<ModalDevolutionReasonsComponent>
  ) {}

  ngOnInit(): void {

    this.lots = this.data.map((lot: any) => ({
      id: lot.id,
      lote: lot.numero,
      quantidade: lot.quantidade,
      dataFechamento: lot.dataFechamento ? this.formatDate(lot.dataFechamento) : '-',
      dataEntrega: this.formatDate(lot.dataEntrega),
      motivo: '',
    }));
  }
  formatDate(dateString: string): string {
    if (!dateString) {
      return '-';
    }

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${day}/${month}/${year}`;
  }
  cancel(): void {
    this.dialogRef.close(false);
  }
  submit(): void {
    const payload = {
      lotes: this.lots.map((lot) => ({
        loteId: lot.id,
        motivo: lot.motivo,
      })),
    };

    this.stockyService.lotDevolution(payload).subscribe({
      next: () => {
      this.dialogRef.close(true);
      },
      error: (error: any) => {
        this.toastr.error(error.errors[0] ?? 'Erro ao devolver os lotes do carregamento.');
      },
    });
  }

  get canSubmit(): boolean {
    return (
      this.lots.length > 0 && this.lots.every((lot) => lot.motivo && lot.motivo.trim().length > 0)
    );
  }
}
